export const getNotificationGridConfig =
  (
    reminderSettings,
    patientReminderSettings,
    followUpLabel,
    appointmentsFormLabels,
    secureMessageLabel,
    questionnairesLabel,
    handleInputChange) => (
    [
      {
        name: 'followupNotification',
        emailProperty: 'followUpEmailEnabled',
        smsProperty: 'followUpSmsEnabled',
        typeLabel: followUpLabel,
        isEmailEnabled: reminderSettings.patientFollowUpEmailEnabled,
        isSmsEnabled: reminderSettings.patientFollowUpSmsEnabled,
        isEmailChecked: patientReminderSettings.followUpEmailEnabled,
        isSmsChecked: patientReminderSettings.followUpSmsEnabled,
        isEmailCheckboxReadOnly: false,
        handleInputChange,
      },
      {
        name: 'appointmentNotification',
        emailProperty: 'appointmentEmailEnabled',
        smsProperty: 'appointmentSmsEnabled',
        typeLabel: appointmentsFormLabels.typeLabel,
        isEmailEnabled: reminderSettings.patientAppointmentEmailEnabled,
        isSmsEnabled: reminderSettings.patientAppointmentSmsEnabled,
        isEmailChecked: patientReminderSettings.appointmentEmailEnabled,
        isSmsChecked: patientReminderSettings.appointmentSmsEnabled,
        isSmsCheckboxReadOnly: false,
        handleInputChange,
        info: patientReminderSettings.showAppointmentNotificationDigestHint
          ? appointmentsFormLabels.info : null,
      },
      {
        name: 'secureMessageNotification',
        emailProperty: 'secureMessageEmailEnabled',
        smsProperty: 'secureMessageSmsEnabled',
        typeLabel: secureMessageLabel,
        isEmailEnabled: reminderSettings.patientSecureMessageEmailEnabled,
        isSmsEnabled: reminderSettings.patientSecureMessageSmsEnabled,
        isEmailChecked: patientReminderSettings.secureMessageEmailEnabled,
        isSmsChecked: patientReminderSettings.secureMessageSmsEnabled,
        isEmailCheckboxReadOnly: false,
        handleInputChange,
      },
      {
        name: 'questionnairesNotification',
        emailProperty: 'questionnaireEmailEnabled',
        smsProperty: 'questionnaireSmsEnabled',
        typeLabel: questionnairesLabel,
        isEmailEnabled: reminderSettings.patientQuestionnaireEmailEnabled,
        isSmsEnabled: reminderSettings.patientQuestionnaireSmsEnabled,
        isEmailChecked: patientReminderSettings.questionnaireEmailEnabled,
        isSmsChecked: patientReminderSettings.questionnaireSmsEnabled,
        isEmailCheckboxReadOnly: false,
        handleInputChange,
      },
    ]
  );
